module.exports = __webpack_public_path__ + "d8.no2.e056863d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d8.no2.jpg
// module id = SSD6
// module chunks = 0